export default (countries = [], countryId = null) => {
  const poland =
    countries.length > 0
      ? countries.find(country => {
          return country.name && country.name.toLowerCase() === "polska";
        })
      : null;
  return poland && poland.id && poland.id === countryId ? true : false;
};
